<template>
  <div class="all-container">
    <div class="main2">
      <div class="main2">
        <div class="search" style="min-height:80px;">
          <el-form
            :model="queryParams"
            ref="queryForm"
            :inline="true"
            label-width="85px"
          >
            <el-form-item label="订单编号：" prop="orderNum">
              <el-input
                v-model="queryParams.orderNum"
                placeholder="请输入订单编号"
                clearable
                size="small"
                style="width:180px;"
              />
            </el-form-item>
            <el-form-item label="收货电话：" prop="consigneePhone">
              <el-input
                v-model="queryParams.consigneePhone"
                placeholder="请输入收货电话"
                clearable
                size="small"
                style="width:180px;"
              />
            </el-form-item>

            <el-form-item label="快递单号：" prop="deliveryNum">
              <el-input
                v-model="queryParams.deliveryNum"
                placeholder="请输入快递单号"
                clearable
                size="small"
                style="width:180px;"
              />
            </el-form-item>
            <el-form-item label="订单时间：" prop="beginTime">
              <el-date-picker
                clearable
                size="small"
                style="width: 150px"
                v-model="queryParams.beginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="" prop="endTime" label-width="2px">
              <el-date-picker
                clearable
                size="small"
                style="width: 130px"
                v-model="queryParams.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="截止时间"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button
                icon="el-icon-search"
                size="small"
                style="border-color:#97c5e9"
                @click="search"
                >搜索</el-button
              >
            </el-form-item>
            <el-form-item style="width:600px;">
              

              <span v-html="'\u00a0\u00a0\u00a0\u00a0'"></span>
              <el-button
                icon="el-icon-download"
                size="small"
                style="margin:0;border-color:#97c5e9"
                @click="getBefore2"
                >导出选中</el-button
              >
              <span v-html="'\u00a0\u00a0\u00a0\u00a0'"></span>
              <el-button
                icon="el-icon-download"
                size="small"
                style="margin:0;border-color:#97c5e9"
                @click="getBefore"
                >导出全部</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="list">
          <el-table
            ref="tableF"
            :data="currentPageInfo"
            style="width: 100%"
            :default-expand-all="true"
            :cell-style="{
              'text-align': 'center',
              'border-color': '#dbdbdb',
              'border-top': '35px solid #e7e6e4',
              position: 'relative',
              'background-color': '#f3f1f2',
              'border-right': '1px solid #e7e6e4',
            }"
            :header-cell-style="{
              'background-color': '#b6b6b6',
              color: '#000',
              fontSize: '14px',
              fontWeight: '300',
              'text-align': 'center',
            }"
            @selection-change="SelectionChange"
          >
            <el-table-column type="selection" width="45"> </el-table-column>
            <el-table-column prop="num" align="center" label="序号" width="55">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>

            <el-table-column
              prop="orderNum"
              label="订单信息"
              min-width="150"
              style="position:relative"
            >
              <template slot-scope="scope">
                <div style="position:absolute;left:-50px;top:-30px;">
                  单号：<el-link
                    :underline="false"
                    @click="watchOrder(scope.row)"
                    >{{ scope.row.orderNum }}</el-link
                  >
                </div>

                {{ scope.row.goodsDetail }}
              </template>
            </el-table-column>

            <el-table-column prop="consignee" label="收货人" width="75">
              <template slot-scope="scope">
                {{ scope.row.consignee }}
              </template>
            </el-table-column>

            <el-table-column
              prop="consigneePhone"
              label="收货电话"
              min-width="100"
            >
              <template slot-scope="scope">
                {{ scope.row.consigneePhone }}
              </template>
            </el-table-column>
            <el-table-column
              prop="consigneeAddr"
              label="收货地址"
              min-width="140"
            >
              <template slot-scope="scope">
                {{
                  scope.row.province +
                    scope.row.city +
                    scope.row.area +
                    scope.row.consigneeAddr
                }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="下单时间" min-width="85">
              <template slot-scope="scope">
                {{ scope.row.createTime || "" }}
              </template>
            </el-table-column>
            <el-table-column prop="moneyYun" label="运费" min-width="70">
              <template slot-scope="scope">
                {{ to_f(scope.row.moneyYun || 0.0) }}
              </template>
            </el-table-column>
            <el-table-column prop="moneyGoods" label="商品金额" min-width="80">
              <template slot-scope="scope">
                {{ to_f(scope.row.moneyGoods || 0.0) }}
              </template>
            </el-table-column>

            <el-table-column prop="money" label="总额" min-width="90">
              <template slot-scope="scope">
                {{ to_f(scope.row.money || 0.0) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="consigneeAddr"
              label="订单状态"
              min-width="75"
            >
              <template slot-scope="scope">
                <span>{{ order_status(scope.row.status) || "" }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="75">
              <template slot-scope="scope">
                {{ scope.row.remark }}
              </template>
            </el-table-column>

            <el-table-column width="1" type="expand">
              <template slot-scope="props">
                <el-form
                  inline
                  class="demo-table-expand"
                  style="margin:0 0 0 -70px;background:#f3f1f2;"
                >
                  <el-form-item label="商品数量">
                    <span>{{ props.row.sumGoods || 0 }}</span>
                  </el-form-item>
                  <el-form-item label="快递公司">
                    <span>{{ props.row.deliveryName }}</span>
                  </el-form-item>
                  <el-form-item label="快递单号">
                    <span>{{ props.row.deliveryNum }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                <div>
                  <el-button
                    size="mini"
                    style="border-color:#97c5e9;background:none;"
                    @click="watchOrder(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    size="mini"
                    style="border-color:#97c5e9;margin:5px 0 0;background:none;"
                    v-if="
                      scope.row.status == 0 ||
                        scope.row.status == 1 ||
                        scope.row.status == 2 ||
                        scope.row.status == 3
                    "
                    @click="cancelOrderBefore(scope.row)"
                    >取消</el-button
                  >
                  <span v-html="'\u00a0\u00a0\u00a0\u00a0'"></span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="total flexStyle2" v-if="currentPageInfo.length >= 1">
          <div class="item">
            商品数量合计: <span>{{ goodsTotalNumber }}</span>
          </div>
          <div class="item">
            订单数量合计: <span>{{ currentPageInfo.length }}</span>
          </div>
          <div class="item">
            商品金额合计: <span>{{ to_f(goodsTotalPrice) }}</span
            >元
          </div>
          <div class="item">
            运费合计: <span>{{ to_f(YFTotalPrice) }}</span
            >元
          </div>
          <div class="item">
            订单总额: <span>{{ to_f(DDTotalPrice) }}</span
            >元
          </div>
        </div>
        <el-pagination
          v-if="totalPages > 1"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button
          size="mini"
          v-if="totalPages > 1"
          style="display:inline-block;"
          >GO</el-button
        >
      </div>
    </div>

    <el-dialog title="选择导出列" :visible.sync="down">
      <el-form :model="form">
        <el-form-item>
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <div style="margin: 5px 0;"></div>
          <el-checkbox-group
            @change="handleCheckedChange"
            v-model="form.searchColumn"
          >
            <el-checkbox
              v-for="dataM in exportParametersList"
              :label="dataM.name"
              :key="dataM.id"
              >{{ dataM.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportDown">确认导出</el-button>
        <el-button @click="closeDown">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as math from "mathjs";
import {
  getUrl,
  allSentOrderListRequest,
  cacelOrderRequest,
  exportOrderDeliveredReequest,
} from "../../../public/js/service";

export default {
  props: ["obj"],
  data() {
    // 1.data
    return {
      totalPages: 1, //总页码,
      pageNum: 1, //当前页码
      total: 1, //总条数
      pageSize: 10, //每页条数
      currentPageInfo: [], //数据列表
      token: "", //token
      status: "", //订单状态
      queryParams: {
        orderNum: null,
        beginTime: null,
        endTime: null,
      },
      down: false,
      form: {
        searchColumn: [],
      },
      isAll: true,
      exportParametersList: [],
      statusOptions: [],
      checkAll: false,
      isIndeterminate: true,
    };
  },

  components: {},

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getCurrentPageInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getCurrentPageInfo();
    },

    getCurrentPageInfo() {
      // 3.4.获取订单数据
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderNum: this.queryParams.orderNum,
        params: {
          beginTime: this.queryParams.beginTime,
          endTime: this.queryParams.endTime,
        },
        deliveryNum: this.queryParams.deliveryNum,
        consigneePhone: this.queryParams.consigneePhone,
      };

      allSentOrderListRequest(data).then((res) => {
        if (res) {
          this.total = res.totals || 1;
          this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;
          this.currentPageInfo = res.data;
        }
      });
    },

    cancelOrderBefore(item) {
      // 3.5.取消订单之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认取消订单?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.cancelOrder(item);
          }
        },
      });
    },

    cancelOrder(item) {
      // 3.6.取消订单
      cacelOrderRequest(item.orderId).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });

          setTimeout(() => {
            this.getCurrentPageInfo();
          }, 300);
        }
      });
    },

    search() {
      //检索
      this.pageNum = 1;
      this.getCurrentPageInfo();
    },

    SelectionChange() {},

    watchOrder(item) {
      // 查看订单详情
      this.$router.push("/orderDetail?orderId=" + item.orderId);
    },

    getBefore() {
      this.isAll = true;
      this.down = true;
      if (localStorage.searchColumn) {
        this.form.searchColumn = (localStorage.searchColumn || "").split(",");
        this.handleCheckedChange(this.form.searchColumn);
      }
      console.log(this.form.searchColumn);
    },
    getBefore2() {
      this.isAll = false;
      let isShow = true;
      if (localStorage.searchColumn) {
        this.form.searchColumn = (localStorage.searchColumn || "").split(",");
        this.handleCheckedChange(this.form.searchColumn);
      }
      console.log(this.form.searchColumn);
      let searchId = "";
      if (this.isAll == false) {
        const _selectData = this.$refs.tableF.selection;
        for (let i = 0; i < _selectData.length; i++) {
          if (searchId != "") {
            searchId += ",";
          }
          searchId += _selectData[i].orderId;
        }
        if (searchId == "") {
          isShow = false;
          this.$message({
            type: "success",
            message: "未选中导出",
          });
        }
      }
      this.down = isShow;
    },
    closeDown() {
      this.down = false;
    },
    handleCheckAllChange(val) {
      let oop = [];
      for (let j = 0; j < this.exportParametersList.length; j++) {
        oop.push(this.exportParametersList[j].name);
      }
      this.form.searchColumn = val ? oop : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.exportParametersList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.exportParametersList.length;
    },
    exportDown() {
      // 导出
      let searchId = "";
      let isDown = true;
      if (this.isAll == false) {
        const _selectData = this.$refs.tableF.selection;
        for (let i = 0; i < _selectData.length; i++) {
          if (searchId != "") {
            searchId += ",";
          }
          searchId += _selectData[i].orderId;
        }
        if (searchId == "") {
          isDown = false;
          this.$message({
            type: "error",
            message: "未选中导出",
          });
          return;
        }
      }
      let searchColumn = "";
      let plist = [];
      if (this.form.searchColumn) {
        localStorage.searchColumn = this.form.searchColumn.toString();
        for (var i = 0; i < this.form.searchColumn.length; i++) {
          const name = this.form.searchColumn[i];
          for (var m = 0; m < this.exportParametersList.length; m++) {
            if (this.exportParametersList[m].name == name) {
              plist.push(this.exportParametersList[m].id);
              break;
            }
          }
        }
        searchColumn = plist.toString();
      }
      this.down = false;
      if (isDown) {
        let data = {
          orderNum: this.queryParams.orderNum,
          params: {
            beginTime: this.queryParams.beginTime,
            endTime: this.queryParams.endTime,
          },
          deliveryNum: this.queryParams.deliveryNum,
          consigneePhone: this.queryParams.consigneePhone,
          status: this.status,
        };
        data.searchId = searchId;
        data.searchColumn = searchColumn;
        exportOrderDeliveredReequest(data).then((res) => {
          if (res) {
            var aLink = document.createElement("a");
            aLink.href = getUrl(res.url);
            aLink.download = "订单列表.xls";
            aLink.style.display = "none";
            aLink.target = "_blank";
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink);
          }
        });
      }
    },

    printFn(value) {
      // 3.11.精度算数
      const precision = 14;
      return Number(math.format(value, precision));
    },
  },
  obj: function(val) {
    console.log(val);
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getCurrentPageInfo();
    }
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getCurrentPageInfo(); // 4.1.获取订单数据
    }

    if (localStorage.baseInfo) {
      let obj = JSON.parse(localStorage.baseInfo);
      if (obj.web_order_staus) {
        this.statusOptions = obj.web_order_staus;
      }
    }

    let ary = [];
    ary.push({ id: "orderNum", name: "订单编号" });
    ary.push({ id: "consignee", name: "收件人" });
    ary.push({
      id: "consigneePhone",
      name: "收件电话",
    });
    ary.push({ id: "province", name: "省" });
    ary.push({ id: "city", name: "市" });
    ary.push({ id: "area", name: "县区" });
    ary.push({ id: "consigneeAddr", name: "收件地址" });
    ary.push({ id: "goodsDetail", name: "商品详情" });
    ary.push({ id: "createOrderTime", name: "下单时间" });
    ary.push({ id: "status", name: "订单状态" });
    ary.push({ id: "deliveryName", name: "快递方式" });
    ary.push({ id: "deliveryNum", name: "快递单号" });
    ary.push({ id: "deliveryTime", name: "发货时间" });
    ary.push({ id: "moneyGoods", name: "商品金额" });
    ary.push({ id: "moneyYun", name: "运费" });
    ary.push({ id: "money", name: "总金额" });
    ary.push({ id: "remark", name: "备注" });
    this.exportParametersList = ary;
  },

  computed: {
    // 5.computed
    goodsTotalNumber() {
      // 5.1.商品总数量
      let total = 0;
      this.currentPageInfo.forEach((item) => {
        total += item.sumGoods ? item.sumGoods : 0;
      });
      return this.printFn(total);
    },

    goodsTotalPrice() {
      // 5.2.商品金额合计
      let total = 0.0;
      this.currentPageInfo.forEach((item) => {
        total += item.moneyGoods ? item.moneyGoods : 0;
      });
      return this.printFn(total);
    },

    YFTotalPrice() {
      // 5.3.运费金额合计
      let total = 0.0;
      this.currentPageInfo.forEach((item) => {
        total += item.moneyYun ? item.moneyYun : 0;
      });
      return this.printFn(total);
    },

    DDTotalPrice() {
      // 5.4.订单综合金额合计
      let total = 0.0;
      this.currentPageInfo.forEach((item) => {
        total += item.money ? item.money : 0;
      });
      return this.printFn(total);
    },
  },
};
</script>
